module.exports = __webpack_public_path__ + "static/img/Lindsay-Collins.072592f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lindsay-Collins.jpg
// module id = Eowd
// module chunks = 0